<template>
  <Authentication
    auth-type="login"
    :auth-methods="loginMethods"
    @on-login-or-sign-up-google-user="loginGoogle"
    @on-login-emailuser="loginEmailUser($event)"
  />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import { useNotification } from '@kyvg/vue3-notification'
import Authentication from '@/components/AuthenticationForm.vue'
import { useAuth } from '@/composables/useAuth'
import { useRouter, useRoute } from 'vue-router'

useHead({
  title: 'Login',
  htmlAttrs: {
    class: 'h-full'
  },
})

const router = useRouter()
const route = useRoute()
const { loginOrSignUpGoogle, loginEmail } = useAuth()
const { notify } = useNotification()
const loginMethods = ['google', 'email']

const loginGoogle = async () => {
  await loginOrSignUpGoogle().catch((error) => {
    notify({ type: 'error', title: 'Error', text: error.message || 'An error occurred while trying to login' })
  })

  router.push(route.query.redirect as string || '/')
}

const loginEmailUser = async (formData: { email: string; password: string; }) => {
  await loginEmail(formData.email, formData.password).catch((error) => {
    notify({ type: 'error', title: 'Error', text: error.message || 'An error occurred while trying to login' })
  })

  router.push(route.query.redirect as string || '/')
}
</script>
